// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"895":"95a3e2c379c6f29663af","2888":"1b847303132b3cf95af8","6294":"5efd5ac6468bff9f76e0"}[chunkId] + ".css";
};